<template>
  <div class="obra-action-bar" aria-label="Acoes da obra">
    <v-tooltip v-for="action in actions" :key="action.event" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          class="obra-action-bar__button"
          v-bind="attrs"
          :aria-label="action.label"
          v-on="on"
          @click="$emit(action.event)"
        >
          <v-icon color="white">{{ action.icon }}</v-icon>
        </v-btn>
      </template>
      <span>{{ action.label }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'ObraActionBar',
  props: {
    isFavorite: { type: Boolean, default: false },
    isFollowingProject: { type: Boolean, default: false },
    isFollowingAuthor: { type: Boolean, default: false },
  },
  computed: {
    actions() {
      return [
        {
          event: 'favorite-project',
          icon: this.isFavorite ? 'mdi-bookmark' : 'mdi-bookmark-outline',
          label: this.favoriteLabel,
        },
        {
          event: 'follow-project',
          icon: this.isFollowingProject ? 'mdi-bell' : 'mdi-bell-outline',
          label: this.followProjectLabel,
        },
        {
          event: 'follow-author',
          icon: this.isFollowingAuthor ? 'mdi-account' : 'mdi-account-outline',
          label: this.followAuthorLabel,
        },
      ];
    },
    favoriteLabel() {
      return this.isFavorite ? 'Remover obra dos favoritos' : 'Adicionar obra aos favoritos';
    },
    followProjectLabel() {
      return this.isFollowingProject ? 'Deixar de seguir obra' : 'Seguir obra';
    },
    followAuthorLabel() {
      return this.isFollowingAuthor ? 'Autor seguido' : 'Seguir autor';
    },
  },
};
</script>
